/* Formulaires HubSpot La Fabrique des Minis — chargement à la demande et
   pré-remplissage depuis Shopify.

   Un conteneur [data-hsx-form] porte tout ce qu'il faut :
     data-portal / data-form / data-region  → identifiants de l'embed
     data-ctx="hub"                         → joint le contexte du produit scanné
     data-auto="1"                          → charge sans attendre l'ouverture d'un volet
     data-fn / data-ln / data-em            → identité du client connecté
     data-cid / data-code / data-creche     → id Shopify, code crèche, nom de la crèche
     data-vous-etes / data-objet            → valeurs de liste à présélectionner

   Le script de HubSpot n'est téléchargé qu'au moment où le formulaire est
   réellement demandé : sur le hub, à la première ouverture du volet.

   Rien n'est modifié dans lfdm-hub.js : le contexte produit est relu dans la
   page déjà rendue (titre, référence, GTIN, conditionnement, n° de lot) et
   complété par window.LFDM_SCAN, que le scan expose depuis août 2026. */
(function () {
  var SRC = 'https://js-eu1.hsforms.net/forms/embed/v2.js';
  var libPromise = null;
  var hubCtx = null;

  /* Rappel « Ce que nous recevons avec votre message » sur le hub.
     Masqué tant que la remontée dans HubSpot n'est pas validée : les champs
     Produit concerné et Numéro de lot sont de toute façon visibles dans le
     formulaire. Repasser à true pour le réafficher. */
  var SHOW_RECAP = false;

  function lib() {
    if (window.hbspt && window.hbspt.forms) return Promise.resolve();
    if (libPromise) return libPromise;
    libPromise = new Promise(function (resolve, reject) {
      var t = document.createElement('script');
      t.src = SRC;
      t.charset = 'utf-8';
      t.async = true;
      t.onload = resolve;
      t.onerror = reject;
      document.head.appendChild(t);
    });
    return libPromise;
  }

  /* ---------- contexte du produit scanné, relu dans la page du hub ---------- */
  function hubData() {
    var main = document.getElementById('hub-main');
    if (!main || main.hidden) return null;
    var h1 = main.querySelector('h1');
    if (!h1) return null;

    var d = { title: h1.textContent.trim() };
    var v = main.querySelector('.hub-variant');
    if (v && v.textContent.trim()) { d.title += ' — ' + v.textContent.trim(); }

    var spans = main.querySelectorAll('.hub-meta span');
    for (var i = 0; i < spans.length; i++) {
      var b = spans[i].querySelector('b');
      if (!b) continue;
      var label = spans[i].textContent.replace(b.textContent, '').trim();
      var value = b.textContent.trim();
      if (label.indexOf('Référence') === 0) { d.sku = value; }
      else if (label.indexOf('Code GTIN') === 0) { d.gtin = value; }
      else if (label.indexOf('Conditionnement') === 0) { d.pack = value; }
      else if (label.indexOf('lot') > -1) { d.lot = value; }
    }

    var s = window.LFDM_SCAN || {};
    if (!d.gtin && s.gtin) { d.gtin = s.gtin; }
    if (!d.lot && s.lot) { d.lot = s.lot; }
    return d;
  }

  /* Le contexte est mémorisé dès qu'il a pu être lu une fois : si la carte du
     hub est retirée ou remplacée du DOM au moment où le formulaire s'ouvre,
     le pré-remplissage garde la dernière lecture valable. */
  function hubCtxGet() {
    var p = hubData();
    if (p) { hubCtx = p; }
    return hubCtx || {};
  }

  /* HubSpot ne nomme pas toujours ses champs par le seul nom interne de la
     propriété : selon le type d'objet, l'attribut peut être préfixé
     (0-5/produit_concerne, TICKET.produit_concerne...). On retombe donc sur
     une comparaison de suffixe. */
  function findField(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    if (el) return el;
    var all = form.querySelectorAll('input[name], select[name], textarea[name]');
    for (var i = 0; i < all.length; i++) {
      var n = all[i].getAttribute('name') || '';
      var tail = n.split('/').pop().split('.').pop();
      if (tail === name) return all[i];
    }
    return null;
  }

  /* ---------- écriture d'une valeur dans le formulaire ----------
     Le pré-remplissage est rejoué plusieurs fois après l'affichage : HubSpot
     restaure parfois son propre état juste après onFormReady, ce qui vidait
     les champs. La mémoire `box._hsx` retient ce que nous avons écrit ; si la
     valeur courante en diffère, c'est le client qui a saisi, on ne touche plus.
     Une liste déroulante n'est renseignée que si la valeur correspond
     exactement à une option : une valeur inconnue est ignorée, jamais forcée. */
  function fill(box, form, name, value) {
    if (value === undefined || value === null || value === '') return;
    var el = findField(form, name);
    if (!el) return;

    if (!box._hsx) { box._hsx = {}; }
    var current = String(el.value || '');
    if (current !== '' && box._hsx[name] !== undefined && current !== box._hsx[name]) return;
    if (current === String(value)) { box._hsx[name] = String(value); return; }

    if (el.tagName === 'SELECT') {
      var ok = false;
      for (var i = 0; i < el.options.length; i++) {
        if (el.options[i].value === value) { ok = true; break; }
      }
      if (!ok) return;
    }

    el.value = value;
    box._hsx[name] = String(value);
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function val(form, name) {
    var el = findField(form, name);
    return el ? String(el.value || '').trim() : '';
  }

  /* Intitulé du ticket : « objet — produit (lot 151776) » depuis le hub,
     « objet — Prénom Nom » depuis la page Aide et contact. */
  function subject(box, form) {
    var d = box.dataset;
    var parts = [];
    var objet = val(form, 'objet_de_la_demande') || d.objet || '';
    if (objet) parts.push(objet);

    if (d.ctx === 'hub') {
      var p = hubCtxGet();
      if (p.title) parts.push(p.title);
      var out = parts.join(' — ');
      if (p.lot) out += ' (lot ' + p.lot + ')';
      return out || 'Demande depuis le hub produit';
    }

    var who = [val(form, 'firstname'), val(form, 'lastname')].join(' ').trim();
    if (who) parts.push(who);
    return parts.join(' — ') || 'Demande depuis le site';
  }

  /* HubSpot n'autorise pas à masquer « Nom du ticket » dans le constructeur de
     formulaire. On le compose ici, et la classe posée sur le conteneur permet
     à la feuille de style de le masquer — uniquement si la valeur a bien été
     écrite. En cas d'échec le champ reste visible et saisissable. */
  function syncSubject(box, form) {
    var el = findField(form, 'subject');
    if (!el) return;
    var value = subject(box, form);
    el.value = value;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
    if (String(el.value || '') !== '') { box.classList.add('hsx-auto-subject'); }
  }

  function apply(box, form) {
    if (!form) return;
    var d = box.dataset;
    fill(box, form, 'firstname', d.fn);
    fill(box, form, 'lastname', d.ln);
    fill(box, form, 'email', d.em);
    fill(box, form, 'id_client_shopify', d.cid);
    fill(box, form, 'code_creche', d.code);
    fill(box, form, 'nom_de_la_creche', d.creche);
    fill(box, form, 'vous_etes', d.vousEtes);
    fill(box, form, 'objet_de_la_demande', d.objet);

    if (d.ctx === 'hub') {
      var p = hubCtxGet();
      fill(box, form, 'produit_concerne', p.title);
      fill(box, form, 'code_gtin', p.gtin);
      fill(box, form, 'reference_produit', p.sku);
      fill(box, form, 'conditionnement', p.pack);
      fill(box, form, 'numero_lot', p.lot);
      fill(box, form, 'page_du_hub', window.location.href);
    }

    syncSubject(box, form);
  }

  function prefill(box, form) {
    if (!form) return;
    apply(box, form);

    /* HubSpot peut réécrire ses champs juste après l'affichage : on repasse. */
    var delays = [300, 800, 1500, 3000];
    for (var t = 0; t < delays.length; t++) {
      setTimeout(function () { apply(box, form); }, delays[t]);
    }

    /* L'objet et le nom peuvent encore changer : l'intitulé du ticket suit. */
    var watched = ['objet_de_la_demande', 'firstname', 'lastname'];
    for (var w = 0; w < watched.length; w++) {
      var el = findField(form, watched[w]);
      if (!el) continue;
      el.addEventListener('change', function () { syncSubject(box, form); });
    }
  }

  /* ---------- création du formulaire ---------- */
  function build(box) {
    if (box.getAttribute('data-hsx-built')) return;
    if (!box.dataset.portal || !box.dataset.form) return;
    box.setAttribute('data-hsx-built', '1');

    var target = box.querySelector('.hsx-target');
    if (!target) return;
    if (!target.id) {
      target.id = 'hsx-t-' + Math.floor(Math.random() * 1e9).toString(36);
    }
    var loader = box.querySelector('.hsx-load');

    function formOf(f) {
      var form = f && f.jquery ? f[0] : f;
      if (!form || !form.querySelector) { form = target.querySelector('form'); }
      return form;
    }

    lib().then(function () {
      window.hbspt.forms.create({
        portalId: box.dataset.portal,
        formId: box.dataset.form,
        region: box.dataset.region || 'eu1',
        target: '#' + target.id,
        css: '',
        onFormReady: function (f) {
          if (loader && loader.parentNode) { loader.parentNode.removeChild(loader); }
          try { prefill(box, formOf(f)); } catch (e) {}
        },
        onFormSubmit: function (f) {
          try { syncSubject(box, formOf(f)); } catch (e) {}
        }
      });
    })['catch'](function () {
      if (loader) {
        loader.className = 'hsx-err';
        loader.textContent = 'Le formulaire n’a pas pu se charger. Réessayez, ou écrivez-nous depuis la page Aide et contact.';
      }
    });
  }

  function watch(box) {
    if (box.dataset.auto === '1') { build(box); return; }
    var drawer = box.closest ? box.closest('details') : null;
    if (!drawer) { build(box); return; }
    if (drawer.open) { build(box); return; }
    drawer.addEventListener('toggle', function () {
      if (drawer.open) { build(box); }
    });
  }

  /* ---------- rappel de ce qui part avec le message ---------- */
  function context(p) {
    if (!SHOW_RECAP) return;
    var box = document.getElementById('hsx-ctx');
    if (!box || !p) return;
    var rows = [['Produit', p.title]];
    if (p.sku) rows.push(['Référence', p.sku]);
    if (p.gtin) rows.push(['Code GTIN', p.gtin]);
    if (p.pack) rows.push(['Conditionnement', p.pack]);
    if (p.lot) rows.push(['N° de lot', p.lot]);

    var dl = document.createElement('dl');
    for (var i = 0; i < rows.length; i++) {
      var dt = document.createElement('dt');
      dt.textContent = rows[i][0];
      var dd = document.createElement('dd');
      dd.textContent = rows[i][1];
      dl.appendChild(dt);
      dl.appendChild(dd);
    }
    var h3 = document.createElement('h3');
    h3.textContent = 'Ce que nous recevons avec votre message';
    box.textContent = '';
    box.appendChild(h3);
    box.appendChild(dl);
    box.hidden = false;
  }

  /* Le volet du hub n'apparaît qu'une fois le produit identifié : inutile de
     proposer « une question sur ce produit » sur un écran d'erreur.
     lfdm-hub.js rend la page sans émettre d'événement, d'où la surveillance. */
  function waitHub() {
    var wrap = document.querySelector('[data-hsx-scope="hub"]');
    if (!wrap) return;
    var tries = 0;
    var timer = setInterval(function () {
      var p = hubData();
      tries++;
      if (p) {
        clearInterval(timer);
        hubCtx = p;
        wrap.hidden = false;
        context(p);
      } else if (tries > 80) {
        clearInterval(timer);
      }
    }, 150);
  }

  function init() {
    var list = document.querySelectorAll('[data-hsx-form]');
    for (var i = 0; i < list.length; i++) { watch(list[i]); }
    waitHub();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();